// extracted by mini-css-extract-plugin
export default {"cls1":"CZm4dxdlWP37tcfKP4n_","cls2":"NrEyqbSLSP9336UsC2g1 CZm4dxdlWP37tcfKP4n_"};